import "../../../../shared/icons/insurance/checkin.png";
import "../../../../shared/icons/insurance/service.png";
import "../../../../shared/icons/insurance/verify.png";
import "../../../../shared/icons/insurance/safety.png";
require("./index.less");